export const API_URL = 'https://admin.thirdrailcreative.com/wp-json/wp/v2';
export const PUBLIC_URL = window.location.host.indexOf('localhost') > -1 ? '' : '/wp-content/themes/3rc';
